import { Injectable, inject } from '@angular/core';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import type { LogRecordExporter } from '@opentelemetry/sdk-logs';

import { MtcExporterUtilsService } from '../mtc-exporter-utils.service';

@Injectable()
export class MtcLogRecordExporter extends OTLPLogExporter implements LogRecordExporter {
    constructor() {
        const mtcExporter = inject(MtcExporterUtilsService);
        const baseUrl = mtcExporter.getEndpointBaseUrl();
        const url = baseUrl ? `${baseUrl}/v1/logs` : undefined;

        super({
            url,
            concurrencyLimit: 10,
            headers: mtcExporter.headers
        });
    }
}
